import { Link, useParams } from "react-router-dom"
import EmptyMessage from "@/components/common/EmptyMessage"
import Loading from "@/components/common/Loading"
import { sanitizeHtml } from "@/domain/common/utils/HtmlUtils"
import { sportLabel } from "@/domain/fight/model/Fight"
import { useTournamentDetail } from "@/domain/tournament/hooks/TournamentDetailHook"

export default function TournamentDetailPage() {
  const { id = "" } = useParams()
  const { useTournamentDetailState } = useTournamentDetail(id)
  const { detail, isLoaded, errorMessage } = useTournamentDetailState()

  if (!id) return <EmptyMessage message="대회 정보를 찾을 수 없습니다." />
  if (!isLoaded) return <Loading label="대회 정보를 불러오는 중" />
  if (errorMessage || !detail) {
    return (
      <section className="app-page">
        <p
          role="alert"
          className="app-alert app-alert-error"
        >
          {errorMessage || "대회 정보를 찾을 수 없습니다."}
        </p>
      </section>
    )
  }

  // 안내사항은 운영자가 입력한 값이라 렌더 전에 반드시 sanitize 한다
  const safeNotice = sanitizeHtml(detail.notice)

  return (
    <section className="app-page max-w-[896px]">
      <div className="app-page-head">
        <p className="app-txt-eyebrow text-app-primary-600">TOURNAMENT</p>
        <h1 className="app-txt-h1 mt-3">{detail.name}</h1>
        <p className="app-txt-body2 mt-3 text-app-text-200">
          {detail.statusLabel}
        </p>
      </div>

      <dl className="app-card grid gap-5 sm:grid-cols-2">
        <div>
          <dt className="app-txt-caption text-app-text-200">장소</dt>
          <dd className="app-txt-body1 mt-1.5 font-medium">{detail.venue}</dd>
        </div>
        <div>
          <dt className="app-txt-caption text-app-text-200">대회일</dt>
          <dd className="app-txt-body1 mt-1.5 font-medium">
            {detail.periodText}
          </dd>
        </div>
        <div className="sm:col-span-2">
          <dt className="app-txt-caption text-app-text-200">접수기간</dt>
          <dd className="app-txt-body1 mt-1.5 font-medium">
            {detail.entryOpenText} ~ {detail.entryCloseText}
          </dd>
        </div>
        <div className="sm:col-span-2">
          <dt className="app-txt-caption text-app-text-200">개최 종목</dt>
          <dd className="app-txt-body1 mt-1.5 font-medium">
            {detail.sports.map(sportLabel).join(", ")}
          </dd>
        </div>
      </dl>

      <section className="app-card mt-5">
        <h2 className="app-txt-h3">안내사항</h2>

        {safeNotice ? (
          <div
            className="board-content app-txt-body2 mt-4 leading-7 text-app-text-300"
            dangerouslySetInnerHTML={{ __html: safeNotice }}
          />
        ) : (
          <p className="app-txt-body2 mt-4 leading-7 text-app-text-200">
            등록된 안내사항이 없습니다.
          </p>
        )}
      </section>

      {detail.isEntryOpen ? (
        <Link
          to={`/application?tournamentId=${detail.id}`}
          className="focus-ring app-btn app-btn-lg app-btn-primary app-btn-block mt-8"
        >
          참가신청
        </Link>
      ) : (
        <p
          role="status"
          className="app-txt-body2 mt-8 border border-app-secondary-500 bg-app-secondary-100 py-3.5 text-center text-app-text-200"
        >
          지금은 접수 기간이 아닙니다.
        </p>
      )}
    </section>
  )
}
